module.exports = __webpack_public_path__ + "media/images/team/jesus-duque-c2cadbaa7afc670f5952dd9188eb34c9.png";